import { render, staticRenderFns } from "./NomineeCard.vue?vue&type=template&id=be95df02&"
import script from "./NomineeCard.vue?vue&type=script&lang=js&"
export * from "./NomineeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports